import { api } from "api";
import type { NonIndexRouteObject } from "react-router-dom";

import PriceMonitorWhitelistRoute from "./PriceMonitorWhitelistRoute";

export const priceMonitorRoute: NonIndexRouteObject = {
  loader: () => api.listWhitelist("price-monitor"),
  element: <PriceMonitorWhitelistRoute />,
};
